import React from 'react';
import { useTranslation } from 'react-i18next';

import AccommodationType from 'component/Search/Filter/AccommodationType';
import AiSmartFilter from 'component/Search/Filter/AiSmartFilter';
import Ambience from 'component/Search/Filter/Ambience';
import AmenitiesAndService from 'component/Search/Filter/AmenitiesAndService';
import Apply from 'component/Search/Filter/Apply';
import Cancellation from 'component/Search/Filter/Cancellation';
import ChildrenOffer from 'component/Search/Filter/ChildrenOffer';
import Flight from 'component/Search/Filter/Flight';
import GuestRating from 'component/Search/Filter/GuestRating';
import HotelCategory from 'component/Search/Filter/HotelCategory';
import MealType from 'component/Search/Filter/MealType';
import PopularFilter from 'component/Search/Filter/PopularFilter';
import PriceSlider from 'component/Search/Filter/PriceSlider';
import Rebook from 'component/Search/Filter/Rebook';
import Reset from 'component/Search/Filter/Reset';
import RoomType from 'component/Search/Filter/RoomType';
import ScopedAttribute from 'component/Search/Filter/ScopedAttribute';
import { MetaValue } from 'component/Search/Filter/Segment/__hooks/useDisabledStatus';
import Special from 'component/Search/Filter/Special';
import Sport from 'component/Search/Filter/Sport';
import TourOperator from 'component/Search/Filter/TourOperator';
import Transfer from 'component/Search/Filter/Transfer';
import ViewType from 'component/Search/Filter/ViewType';

import { Feature } from 'config/features';
import {
    beachListArray,
    hotelAmenitiesAndServiceListArray,
    viewTypeListArray,
    wellnessListArray,
} from 'config/Filter/sectionCollection';

import { useFeatureList } from 'hooks/useFeature';
import { QaIdentifier, useQa } from 'hooks/useQa';

import FeatureHelper from 'utility/Toggle/Feature';

import styles from './List.module.scss';

const List = () => {
    const { t } = useTranslation();
    const qaAttr = useQa(QaIdentifier.Search_Filter_Container);
    const [
        isRepositioningFlexFilterAfterPopularActive,
        isRepositioningFlexFilterAfterPriceSliderActive,
        isS3AccommodationCategoryFilterActive,
    ] = useFeatureList(
        Feature.RepositioningFlexFilterAfterPopular,
        Feature.RepositioningFlexFilterAfterPriceSlider,
        Feature.S3AccommodationCategoryGroupFilter
    );
    const isFlexFilterOnTopActive =
        !isRepositioningFlexFilterAfterPopularActive &&
        !isRepositioningFlexFilterAfterPriceSliderActive;

    return (
        <div {...qaAttr} className={styles.FilterList}>
            <header>{t('TRANS-filter')}</header>
            <FeatureHelper name={Feature.S3KiFilter}>
                <AiSmartFilter />
            </FeatureHelper>
            {isFlexFilterOnTopActive && (
                <>
                    <Cancellation />
                    <Rebook />
                    <Special />
                    <PriceSlider />
                    <PopularFilter />
                </>
            )}
            {isRepositioningFlexFilterAfterPriceSliderActive && (
                <>
                    <PopularFilter />
                    <PriceSlider />
                    <Cancellation />
                    <Rebook />
                    <Special />
                </>
            )}

            {isRepositioningFlexFilterAfterPopularActive && (
                <>
                    <PriceSlider />
                    <PopularFilter />
                    <Cancellation />
                    <Rebook />
                    <Special />
                </>
            )}
            <HotelCategory />
            <GuestRating />
            <MealType />
            <RoomType />
            <ViewType viewTypeListArray={viewTypeListArray} />
            <ScopedAttribute
                attributeListArray={beachListArray}
                headlineKey="TRANS-beach-features"
                qaIdentifier={QaIdentifier.Search_Filter_Section_Beach}
                refKey="Strandmerkmale"
            />
            {isS3AccommodationCategoryFilterActive && <AccommodationType />}
            <AmenitiesAndService
                disableWhen={MetaValue.NoResult}
                attributeListArray={hotelAmenitiesAndServiceListArray}
                headlineKey="TRANS-hotel-amenities-and-service"
            />
            <ChildrenOffer />
            <Ambience />
            <Sport />
            <ScopedAttribute
                attributeListArray={wellnessListArray}
                headlineKey="TRANS-wellness-offers"
                qaIdentifier={QaIdentifier.Search_Filter_Section_Wellness}
                refKey="Wellnessangebote"
            />
            <Flight />
            <Transfer />
            {<TourOperator />}
            <Reset />
            <FeatureHelper name={Feature.ManualFilterSubmit}>
                <Apply />
            </FeatureHelper>
        </div>
    );
};

export default List;
